module.exports = __webpack_public_path__ + "static/media/CV.d3bd77ab.pdf";